import { render } from "./LeadsList.vue?vue&type=template&id=44268ec5"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__